var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgDairy = function SvgDairy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.172 17.355a2 2 0 002 2h6.727a.602.602 0 00.601-.598V6.49l-1.504-2.394V2.598A.602.602 0 0018.394 2h-5.116a.602.602 0 00-.602.598v1.497l-1.504 2.394v10.866z",
    fill: "url(#Dairy_svg__paint0_linear_1120_205050)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.501 6.488v12.269a.602.602 0 01-.602.598h-2.407V6.488h3.01z",
    fill: "url(#Dairy_svg__paint1_linear_1120_205050)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.996 4.095L17.49 6.489h-6.32l1.505-2.394h6.32z",
    fill: "url(#Dairy_svg__paint2_linear_1120_205050)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.501 6.489h-3.01l1.506-2.394L20.5 6.489z",
    fill: "url(#Dairy_svg__paint3_linear_1120_205050)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.443 9.237a.3.3 0 01-.3-.299V7.741h-1.806a.3.3 0 01-.301-.3.3.3 0 01.3-.298h2.107a.3.3 0 01.301.299v1.496a.3.3 0 01-.3.3z",
    fill: "url(#Dairy_svg__paint4_linear_1120_205050)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.81 17.794a6.25 6.25 0 01-3.686 1.535h-.006a8.83 8.83 0 01-.816.04 6.874 6.874 0 01-3.753-1.003l-.006-.003c-.568-.36-.688-.759-.689-1.257 0-.498.525-1.514.825-2.103V15l3.078-6.365a.607.607 0 011.09 0l4.095 8.471a.592.592 0 01-.132.688z",
    fill: "url(#Dairy_svg__paint5_linear_1120_205050)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.622 17.36a.595.595 0 01-.19.434c-.584.541-2.022 1.574-4.508 1.574H8.302c.286 0 .557-.015.816-.04h.006a6.25 6.25 0 003.686-1.534.592.592 0 00.132-.689l-4.095-8.47a.602.602 0 00-.545-.34h1.622a.599.599 0 01.545.34l4.095 8.47c.038.08.058.167.058.255z",
    fill: "url(#Dairy_svg__paint6_linear_1120_205050)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.947 17.872a.75.75 0 00.752-.748.75.75 0 00-.752-.748.75.75 0 00-.752.748.75.75 0 00.752.748z",
    fill: "url(#Dairy_svg__paint7_linear_1120_205050)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.699 13.982a.6.6 0 00.602-.598.6.6 0 00-.602-.599.6.6 0 00-.602.599.6.6 0 00.602.598z",
    fill: "url(#Dairy_svg__paint8_linear_1120_205050)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.956 17.273a1.05 1.05 0 001.054-1.047 1.05 1.05 0 00-1.054-1.047 1.05 1.05 0 00-1.053 1.047 1.05 1.05 0 001.053 1.047z",
    fill: "url(#Dairy_svg__paint9_linear_1120_205050)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.504 13.682a.3.3 0 00.301-.299.3.3 0 00-.3-.299.3.3 0 00-.302.3.3.3 0 00.301.298z",
    fill: "url(#Dairy_svg__paint10_linear_1120_205050)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.796 15.18a.3.3 0 00.3-.3.3.3 0 00-.3-.299.3.3 0 00-.301.3.3.3 0 00.3.299z",
    fill: "url(#Dairy_svg__paint11_linear_1120_205050)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.602 12.186a.3.3 0 00.3-.299.3.3 0 00-.3-.3.3.3 0 00-.301.3.3.3 0 00.3.3z",
    fill: "url(#Dairy_svg__paint12_linear_1120_205050)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Dairy_svg__paint0_linear_1120_205050",
    x1: 14.036,
    y1: 2.482,
    x2: 13.334,
    y2: 14.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BBAF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Dairy_svg__paint1_linear_1120_205050",
    x1: 18.804,
    y1: 19.195,
    x2: 18.645,
    y2: 5.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#529DE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FD1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Dairy_svg__paint2_linear_1120_205050",
    x1: 15.652,
    y1: 4.089,
    x2: 15.012,
    y2: 6.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEEFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0E8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Dairy_svg__paint3_linear_1120_205050",
    x1: 18.562,
    y1: 8.107,
    x2: 18.894,
    y2: 3.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#529DE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FD1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Dairy_svg__paint4_linear_1120_205050",
    x1: 13.793,
    y1: 6.5,
    x2: 16.764,
    y2: 10.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.69
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Dairy_svg__paint5_linear_1120_205050",
    x1: 8.771,
    y1: 8.297,
    x2: 8.771,
    y2: 19.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3D661"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Dairy_svg__paint6_linear_1120_205050",
    x1: 10.601,
    y1: 8.279,
    x2: 11.452,
    y2: 19.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4B912"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Dairy_svg__paint7_linear_1120_205050",
    x1: 6.836,
    y1: 15.365,
    x2: 6.936,
    y2: 17.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F29C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29C1F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Dairy_svg__paint8_linear_1120_205050",
    x1: 7.61,
    y1: 11.976,
    x2: 7.69,
    y2: 14.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F29C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29C1F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Dairy_svg__paint9_linear_1120_205050",
    x1: 9.8,
    y1: 13.763,
    x2: 9.94,
    y2: 17.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F29C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29C1F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Dairy_svg__paint10_linear_1120_205050",
    x1: 9.504,
    y1: 13.084,
    x2: 9.504,
    y2: 13.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0C419"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0C419",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Dairy_svg__paint11_linear_1120_205050",
    x1: 6.796,
    y1: 14.581,
    x2: 6.796,
    y2: 15.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0C419"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0C419",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Dairy_svg__paint12_linear_1120_205050",
    x1: 8.602,
    y1: 11.588,
    x2: 8.602,
    y2: 12.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0C419"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0C419",
    stopOpacity: 0
  })))));
};
export default __webpack_public_path__ + "static/media/Dairy.f24bb4cb.svg";
export { SvgDairy as ReactComponent };